export default __webpack_public_path__ + "static/media/desktop_venue_calendar.9cf89049.webp";